import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box, Inline } from '@atlaskit/primitives/compiled';

import { useAdaptiveSmartCardVariant } from '../../hooks/use-adaptive-smart-card-variant';
import { LuminaSectionElement } from '../element/lumina-section-element';

import type { SectionProps } from './types';
import { getElementKey } from './utils';

const styles = cssMap({
	leftColumnStyles: {
		flexGrow: 1,
		flexShrink: 1,
		minWidth: '0px',
	},
	rightColumnStyles: {
		flexShrink: 0,
		minWidth: '0px',
	},
});

const REQUIRED_ELEMENTS_COUNT = 2;

export const TwoColumnSection = ({
	elements,
	key,
	isFoldable = false,
}: SectionProps): React.JSX.Element | null => {
	const {
		textContentRef,
		leftNeedsMeasurement,
		rightNeedsMeasurement,
		leftElements,
		rightElements,
		cardVariant,
	} = useAdaptiveSmartCardVariant(elements);

	if (elements.length < REQUIRED_ELEMENTS_COUNT) {
		return null;
	}

	return (
		<Inline space="space.200" grow="fill">
			<Box
				xcss={styles.leftColumnStyles}
				ref={leftNeedsMeasurement ? textContentRef : undefined}
				testId="two-column-layout-left"
			>
				{leftElements.map((element, index) => (
					<LuminaSectionElement
						component={element}
						position="two-columns-left"
						key={getElementKey({ key, pos: element.attributes?.pos, index })}
						isFoldable={isFoldable}
						variant={cardVariant}
					/>
				))}
			</Box>
			<Box
				xcss={styles.rightColumnStyles}
				ref={rightNeedsMeasurement ? textContentRef : undefined}
				testId="two-column-layout-right"
			>
				{rightElements.map((element, index) => (
					<LuminaSectionElement
						component={element}
						position="two-columns-right"
						key={getElementKey({ key, pos: element.attributes?.pos, index })}
						isFoldable={isFoldable}
						variant={cardVariant}
					/>
				))}
			</Box>
		</Inline>
	);
};
